import { render } from "./SaveLicense.vue?vue&type=template&id=80a7b07a"
import script from "./SaveLicense.vue?vue&type=script&lang=js"
export * from "./SaveLicense.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__